export default {"src":"/_next/static/media/ArgoCD.02650d3e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};